import { For, Show, type Component } from 'solid-js'
import { Trans } from '@mbarzda/solid-i18next'
import { type DashboardMediaItem } from '../../features/dashboard/domain/models/dashboard'
import Music from '../../assets/icons/Music'
import Video from '../../assets/icons/Video'

interface DashboardMediaListProps {
  titleKey: string
  items: DashboardMediaItem[]
  mediaType: 'song' | 'video'
}

const DashboardMediaList: Component<DashboardMediaListProps> = (props) => {
  const isPositive = (diff: number) => diff >= 0
  const formatDiff = (diff: number) => `${Math.abs(diff * 100).toFixed(1)}%`

  return (
    <div class="flex flex-col gap-4">
      <h4 class="text-sm font-semibold text-gray-900">
        <Trans key={props.titleKey} />
      </h4>
      <div class="flex flex-col">
        <For each={props.items}>
          {(item, index) => (
            <div
              class={`flex items-center justify-between py-3 ${
                index() === props.items.length - 1 ? 'pb-0' : 'border-b border-gray-100'
              }`}
            >
              <div class="flex items-center gap-3">
                <span class="w-4 text-xs font-medium text-gray-400">{index() + 1}.</span>
                <Show
                  when={item.imageUrl}
                  fallback={props.mediaType === 'song' ? <Music size={12} /> : <Video size={12} />}
                >
                  <img src={item.imageUrl} alt={item.name} class="size-12 rounded-lg object-cover aspect-square" />
                </Show>
                <div class="flex flex-col">
                  <span class="text-sm font-medium text-gray-900 line-clamp-1">{item.name}</span>
                  <div class="flex items-center gap-2">
                    <span class="text-xs font-bold text-gray-900">{item.value.toLocaleString('en-US')}</span>
                    <div
                      class={`flex items-center text-[10px] font-medium ${
                        isPositive(item.diff) ? 'text-green-600' : 'text-red-600'
                      }`}
                    >
                      {isPositive(item.diff) ? '↑' : '↓'}
                      <span class="ml-0.5">{formatDiff(item.diff)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </For>
      </div>
    </div>
  )
}

export default DashboardMediaList
